<template>
  <div style="display: inline-block">
    <gallery
      :id="id"
      :images="imgs"
      :index="index"
      @close="index = null"
    ></gallery>

    <div v-if="imgs.length != 0" @click="index = 0">
      <div style="color: #409eff">{{ text }}({{ imgs.length }}张)</div>
    </div>
    <div v-else class="grey">无</div>
  </div>
</template>

<script>
import VueGallery from "vue-gallery";
export default {
  components: {
    gallery: VueGallery,
  },

  // props: ["srcs"],

  props: {
    text: {
      type: String,
      default: "查看凭证",
    },
    // eslint-disable-next-line vue/require-default-prop
    srcs: String,
  },
  data() {
    return {
      index: null,
    };
  },
  computed: {
    imgs() {
      if (this.srcs == null || this.srcs.trim() === "") {
        return [];
      }
      const ss = this.srcs
        .replace(/files.eshangying.com/g, "esyfiles.jianyingkeji.com")
        .split(";");
      return ss.filter((s) => s.trim() !== "");
    },
    id() {
      const ALL_NUMBERS = "0123456789";
      let s = "";
      for (let i = 0; i < 5; i++) {
        const r = Math.floor(Math.random() * 10);
        s = s + ALL_NUMBERS.charAt(r);
      }
      return "id" + s;
    },
  },
  methods: {},
};
</script>
<style scoped>
.mask {
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  height: 100%;
  width: 100%;
  z-index: 9999;
}

.bigImg {
  position: relative;
  width: auto;
  margin: 0 auto;
  top: 50px;
  height: auto;
  text-align: center;
}

.bigImg img {
  height: auto;
  max-width: 70%;
  max-height: 700px;
}
</style>
